import React, { useState, useEffect } from "react";
import { Clock } from "lucide-react";

function remaining(endsAt) {
  const diff = new Date(endsAt).getTime() - Date.now();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
}

export default function Countdown({ endsAt, className = "" }) {
  const [t, setT] = useState(() => (endsAt ? remaining(endsAt) : null));
  useEffect(() => {
    if (!endsAt) return;
    const id = setInterval(() => setT(remaining(endsAt)), 1000);
    return () => clearInterval(id);
  }, [endsAt]);
  if (!endsAt) return null;
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <span className={`inline-flex items-center gap-1.5 font-mono text-xs text-neon ${className}`} data-testid="battle-countdown">
      <Clock className="w-3.5 h-3.5" />
      {t ? (t.d > 0 ? `${t.d}d ${pad(t.h)}h ${pad(t.m)}m` : `${pad(t.h)}:${pad(t.m)}:${pad(t.s)}`) : "Closing now"}
    </span>
  );
}
